import React from 'react';
import { connect } from 'react-redux';
import moment from "moment";

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import WorkReportTemplate from './WorkReportTemplate';
import weeklyReportService from '../../services/WorkReport/weekly-report-service';
import {
	increaseWeeklyReportLoadCounter,
	fetchWeeklyReportList,
	setWeeklyReportFilter,
	updateWeeklyReport,
	submitWeeklyReport,
	submitCurrentWeeklyReport
} from '../../actions/work-report-actions';
import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Row,
	Col,
	Icon,
	Radio,
	Form,
	Input,
	Select,
	DatePicker,
	Upload
} from 'antd';
// import DynamicForm from "../../components/frame/DynamicForm";
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
import logoImg from '../../assets/images/CJL-logo.png';

import rosterService from '../../services/EmployeeManagement/roster-service.js';

const webConfig = require('../../config.json');

class WeeklyReport extends React.Component {

	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedIDs: ids });
		},
		getCheckboxProps: record => ({
			disabled: record.status !== 0
		}),
	}
	state = {
		certificatePreviewVisiable: false,
		certificatePreviewImage: "",
		summaryImagePreviewVisiable: false,
		summaryImagePreviewImage: "",
		isAddtion: false,
		loading: false,
		submitLoading: false
	}

	componentWillMount() {
		if ("loaded" !== this.props.workReport.weeklyReportStatus) {
			this.props.increaseWeeklyReportLoadCounter();
		}
		if (this.props.routing.location.pathname.split('/')[3]) {
			this.setState({
				openDetail: false,
				currentModalStatus: true
			});
			weeklyReportService.initWeeklyReport({ type_id: 2 }, res => {

				this.setState({
					weeklyReportTemplate: JSON.parse(res.data.template),
					real_name: res.data.employee.real_name,
					department_name: res.data.employee.department_name,
					position_name: res.data.employee.position_name,
					district: res.data.district,
					type_id: res.data.type_id,
					report_id: null,
					date_1: null,
					date_2: null,
					images: res.data.images ? JSON.parse(res.data.images) : [],
					summary: res.data.summary,
					summary_images: res.data.summary_images ? JSON.parse(res.data.summary_images) : [],
					currentData: {
						question: "",
						employee_id_1: "",
						employee_id_2: "",
						employee_id_3: "",
						employee_1_reason: "",
						employee_2_reason: "",
						employee_3_reason: "",
					}
				});
				if (res.data.template_name && res.data.template_name == "周工作报告") {
					this.setState({
						isAddtion: true
					})
				}
				if (res.data.template_name && res.data.template_name == "普通外教周报（转正后）") {
					this.setState({
						isforeign: true
					})
				}
			});
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.workReport.weeklyReportLoadCounter !== this.props.workReport.weeklyReportLoadCounter) {
			let gets = { type_id: 2 };
			Object.keys(nextProps.workReport.weeklyReportFilters).forEach(key => {
				if (nextProps.workReport.weeklyReportFilters[key]) {
					gets[key] = nextProps.workReport.weeklyReportFilters[key];
				}
			});
			this.props.fetchWeeklyReportList(gets);
		}
	}

	setStartDateFilter = (value, date) => {
		this.props.setWeeklyReportFilter({ start_date: date, page: 1 });
	}

	setEndDateFilter = (value, date) => {
		this.props.setWeeklyReportFilter({ end_date: date, page: 1 });
	}
	setStartDate = (val) => {
		if (val) {
			val = val.format("YYYY-MM-DD")
		}
		this.setState({ date_1: val });
	}
	setEndDate = (val) => {
		if (val) {
			val = val.format("YYYY-MM-DD")
		}
		this.setState({ date_2: val });
	}

	setStatusFilter = event => {
		this.props.setWeeklyReportFilter({ status: event.target.value, page: 1 });
	}

	setPageFilter = pagination => {
		this.props.setWeeklyReportFilter({ page: pagination.current });
	}

	newWeeklyReport = () => {
		this.setState({
			openDetail: false,
			currentModalStatus: true
		});
		weeklyReportService.initWeeklyReport({ type_id: 2 }, res => {
			console.log(res);
			this.setState({
				weeklyReportTemplate: JSON.parse(res.data.template),
				real_name: res.data.employee.real_name,
				department_name: res.data.employee.department_name,
				position_name: res.data.employee.position_name,
				district: res.data.district,
				type_id: res.data.type_id,
				report_id: null,
				date_1: null,
				date_2: null,
				images: res.data.images ? JSON.parse(res.data.images) : [],
				summary: res.data.summary,
				summary_images: res.data.summary_images ? JSON.parse(res.data.summary_images) : [],
				currentData: {
					question: "",
					employee_id_1: "",
					employee_id_2: "",
					employee_id_3: "",
					employee_1_reason: "",
					employee_2_reason: "",
					employee_3_reason: "",
				}
			});
			if (res.data.template_name && res.data.template_name == "周工作报告") {
				this.setState({
					isAddtion: true
				})
			}
			if (res.data.template_name && res.data.template_name == "普通外教周报（转正后）") {
				this.setState({
					isforeign: true
				})
			}
		});
	}

	saveCurrentReport = status => {
		if (!this.state.date_1) {
			message.error("请选择开始日期", 4);
			return false;
		}
		if (!this.state.date_2) {
			message.error("请选择结束日期", 4);
			return false;
		}
		if (!this.state.currentData.employee_id_1 && this.state.employee1_search && this.state.employee1_search.length > 0) {
			message.error("请选择最佳员工1或者清空最佳员工1文本框", 4);
			return false;
		}
		if (!this.state.currentData.employee_id_2 && this.state.employee2_search) {
			message.error("请选择最佳员工2或者清空最佳员工2文本框", 4);
			return false;
		}
		if (!this.state.currentData.employee_id_3 && this.state.employee3_search) {
			message.error("请选择最佳员工3或者清空最佳员工3文本框", 4);
			return false;
		}
		if (status === 1) {
			this.setState({ submitLoading: true })
		} else {
			this.setState({ loading: true })
		}
		this.props.form.validateFields((err, values) => {
			let posts = {
				status: status,
				table_content: JSON.stringify(this.state.weeklyReportTemplate),
				type_id: this.state.type_id,
				date_1: this.state.date_1,
				date_2: this.state.date_2,
				best_employees: {
					employee_id_1: this.state.currentData.employee_id_1,
					employee_1_reason: values.employee_1_reason,
					employee_id_2: this.state.currentData.employee_id_2,
					employee_2_reason: values.employee_2_reason,
					employee_id_3: this.state.currentData.employee_id_3,
					employee_3_reason: values.employee_3_reason,
				},
				question: values.question,
				summary: values.summary,
			}
			if (!posts.table_content) {
				message.error("报告内容不能为空", 4);
				this.setState({ loading: false, submitLoading: false })
				return;
			}
			if (!values.employee_id_1) {
				posts.best_employees.employee_id_1 = '';
			}
			if (!values.employee_id_2) {
				posts.best_employees.employee_id_2 = '';
			}
			if (!values.employee_id_3) {
				posts.best_employees.employee_id_3 = '';
			}
			posts.images = JSON.stringify(this.state.images);
			posts.summary_images = JSON.stringify(this.state.summary_images);

			if (this.state.report_id) {
				posts = {
					...this.props.workReport.weeklyReportData.Data[this.state.currentIndex],
					...posts
				}
				this.props.updateWeeklyReport(posts, this.state.currentIndex, result => {
					this.setState({ loading: false, submitLoading: false })
					if (result) {
						this.closeCurrentModal();
						message.success("报告保存成功", 4);
					} else {
						message.error("报告保存失败", 4);
					}
				});
			} else {
				weeklyReportService.saveWeeklyReport(posts, res => {
					this.setState({ loading: false, submitLoading: false })
					if (res.data.Success) {
						this.closeCurrentModal();
						this.props.increaseWeeklyReportLoadCounter();
						message.success("报告保存成功", 4);
					} else {
						message.error("报告保存失败" + res.data.Errors[0], 4);
					}
				});
			}
		})


	}

	submitCurrentReport = status => {
		Modal.confirm({
			title: '确定提交报告?报告一旦提交,将无法再修改.',
			okText: '确认',
			cancelText: '取消',
			onOk: () => this.saveCurrentReport(status),
			onCancel: () => { }
		});
	}

	editReportContent = reportContent => {
		this.setState({ weeklyReportTemplate: reportContent });
	}

	closeCurrentModal = () => {
		this.setState({ currentModalStatus: false });
		this.setState({ currentData: null });
		this.setState({employee1_search:null});
		this.setState({employee2_search:null});
		this.setState({employee3_search:null});
	}

	updateWeeklyReport = (record, index, unedit) => {
		this.setState({
			openDetail: unedit,
			currentIndex: index,
			currentModalStatus: true
		}, () => {
			weeklyReportService.fetchWeeklyReportDetail({ modelId: record.id }, res => {
				console.log(res);
				this.setState({
					weeklyReportTemplate: JSON.parse(res.data.work_report.table_content),
					real_name: res.data.employee.real_name,
					department_name: res.data.employee.department_name,
					position_name: res.data.employee.position_name,
					district: res.data.district,
					type_id: res.data.work_report.type_id,
					next_id: res.data.next_id,
					prev_id: res.data.prev_id,
					replies: res.data.replies,
					report_id: res.data.work_report.id,
					date_1: res.data.work_report.date_1,
					date_2: res.data.work_report.date_2,
					currentData: {
						employee_id_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_1 ? res.data.work_report.best_employees.employee_id_1 : "",
						employee_1_reason: res.data.work_report.best_employees ? res.data.work_report.best_employees.employee_1_reason : "",
						employee_id_2: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_2 ? res.data.work_report.best_employees.employee_id_2 : "",
						employee_2_reason: res.data.work_report.best_employees ? res.data.work_report.best_employees.employee_2_reason : "",
						employee_id_3: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_3 ? res.data.work_report.best_employees.employee_id_3 : "",
						employee_3_reason: res.data.work_report.best_employees ? res.data.work_report.best_employees.employee_3_reason : "",
						employee_name_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_1 ? res.data.work_report.best_employees.employee_name_1 : "",
						employee_name_2: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_2 ? res.data.work_report.best_employees.employee_name_2 : "",
						employee_name_3: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_3 ? res.data.work_report.best_employees.employee_name_3 : "",
						question: res.data.work_report.question
					},
					images: res.data.work_report.images ? JSON.parse(res.data.work_report.images) : [],
					summary: res.data.work_report.summary,
					summary_images: res.data.work_report.summary_images ? JSON.parse(res.data.work_report.summary_images) : [],
				});
				if (res.data.work_report.template_name && res.data.work_report.template_name == "周工作报告") {
					this.setState({
						isAddtion: true
					})
				}
			});
		});
	}

	submitReport = (record, index) => {
		Modal.confirm({
			title: '确定提交报告?报告一旦提交,将无法再修改.',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				let puts = {
					...record,
					status: 1
				}
				this.closeCurrentModal();
				this.props.submitWeeklyReport(puts, index, result => {
					if (result) {
						message.success("报告提交成功", 4);
					} else {
						message.error("报告提交失败", 4);
					}
				});
			},
			onCancel: () => { }
		});
	}

	submitReportOld = (record, index) => {
		Modal.confirm({
			title: '确定提交报告?报告一旦提交,将无法再修改.',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				let puts = {
					...record,
					status: 1
				}
				this.closeCurrentModal();
				this.props.submitCurrentWeeklyReport(puts, index, result => {
					if (result) {
						message.success("报告提交成功", 4);
					} else {
						message.error("报告提交失败", 4);
					}
				});
			},
			onCancel: () => { }
		});
	}

	multiDeleteWeeklyReport = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的报告', 4);
			return false;
		}
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				weeklyReportService.multiDeleteWeeklyReport({ ids: this.state.selectedIDs }, res => {
					if (res.data.Success) {
						message.success('删除报告成功', 4);
						this.props.increaseWeeklyReportLoadCounter();
					} else {
						message.error('删除报告失败' + res.data.Errors, 4);
					}
				});
			},
			onCancel: () => { }
		});
	}

	formColumn = [{
		label: "1",
		key: "employee_id_1",
		type: "employee",
		span: 24
	}, {
		label: "2",
		key: "employee_id_2",
		type: "employee",
		span: 24
	}, {
		label: "3",
		key: "employee_id_3",
		type: "employee",
		span: 24
	}
	]

	selectEmployee1 = value => {
		this.setState({ employee1_search: value });

		this.props.fetchEmployeesList({ real_name: value, for_all: true });
	}
	selectEmployee2 = value => {

		this.setState({ employee2_search: value });
		this.props.fetchEmployeesList({ real_name: value, for_all: true });
	}
	selectEmployee3 = value => {
		this.setState({ employee3_search: value });
		this.props.fetchEmployeesList({ real_name: value, for_all: true });
	}
	AddClassEva = () => {
		var tempJson = this.state.weeklyReportTemplate;
		var array = Array(tempJson)[0];
		array.shift();
		console.log(array);
		array.unshift({
			"type": "title",
			"title": "Class Evaluations and Feedback"
		},
			{
				"type": "rows",
				"headers": [
					{
						"title": "Class Code",
						"width": 4
					},
					{
						"title": "CT",
						"width": 4
					},
					{
						"title": "Further Comments",
						"width": 16
					}
				],
				"values": [
					[
						null,
						null,
						null
					]
				]
			},
			{
				"type": "table",
				"headers": [
					{
						"title": "*",
						"width": 8
					},
					{
						"title": "1",
						"width": 3
					},
					{
						"title": "2",
						"width": 3
					},
					{
						"title": "3",
						"width": 3
					},
					{
						"title": "4",
						"width": 3
					},
					{
						"title": "5",
						"width": 4
					}
				],
				"columns": [
					"Lesson Objectives Achieved",
					"CT & FT Communication",
					"Class Behavior",
					"Student Progression"
				],
				"values": [
					[
						null,
						null,
						null,
						null,
						null,
						null
					],
					[
						null,
						null,
						null,
						null,
						null,
						null
					],
					[
						null,
						null,
						null,
						null,
						null,
						null
					],
					[
						null,
						null,
						null,
						null,
						null,
						null
					]
				]
			});
		this.setState({ weeklyReportTemplate: array });
	}

	setBest1 = (value, event) => {
		let a = 11;
		this.setState({
			// employee_id_1: event.props.employee_id
			currentData: {
				...this.state.currentData,
				employee_id_1: event.props.employee_id
			}
		})
	}

	setBest2 = (value, event) => this.setState({
		currentData: {
			...this.state.currentData,
			employee_id_2: event.props.employee_id
		}
	})

	setBest3 = (value, event) => this.setState({
		currentData: {
			...this.state.currentData,
			employee_id_3: event.props.employee_id
		}
	})

	checkFileType = file => {
		const typeCheck = "image/jpeg" === file.type || "image/png" === file.type
		if (!typeCheck) {
			message.error("请上传合法的PNG或者JPEG图片!", 4)
		}
		// const sizeCheck = file.size < 2 * 1024 * 1024
		// if (!sizeCheck) {
		// 	message.error("上传图片的大小不能超过2M!", 4)
		// }
		return typeCheck ;//&& sizeCheck;
	}

	////////////Start of upload image////////////////
	uploadCertificateImage = event => {
		const formData = new FormData();
		formData.append("uploadedFile", event.file)

		this.setState({
			isUploadingCertificateImage: true
		}, () => rosterService.uploadSummaryImage(formData, result => {
			if (result.data.Success) {
				this.setState({
					isUploadingCertificateImage: false,
					images: [
						...this.state.images,
						{
							uid: event.file.uid,
							name: event.file.name,
							status: 'done',
							url: result.data.Object
						}
					]
				})
			} else {
				this.setState({
					isUploadingCertificateImage: false
				})
				message.error("上传图片 " + event.file.name + " 出错, " + result.data.Errors[0], 4)
			}
		}, error => {
			this.setState({ isUploadingCertificateImage: false })
			message.error("上传图片出错", 4)
		}))
	}

	previewCertificate = image => this.setState({
		certificatePreviewVisiable: true,
		certificatePreviewImage: image.url
	})

	removeCertificate = image => {
		const imageIndex = this.state.images.map(image => image.uid).indexOf(image.uid)
		this.setState({
			images: [
				...this.state.images.slice(0, imageIndex),
				...this.state.images.slice(imageIndex + 1)
			]
		})
	}

	toggleCertificatePreviewModal = () => this.setState({
		certificatePreviewVisiable: !this.state.certificatePreviewVisiable
	})
	////////////End of upload image////////////////

	////////////Start of upload summary image////////////////
	uploadSummaryImage = event => {
		const formData = new FormData();
		formData.append("uploadedFile", event.file)

		this.setState({
			isUploadingSummaryImage: true
		}, () => rosterService.uploadSummaryImage(formData, result => {
			if (result.data.Success) {
				this.setState({
					isUploadingSummaryImage: false,
					summary_images: [
						...this.state.summary_images,
						{
							uid: event.file.uid,
							name: event.file.name,
							status: 'done',
							url: result.data.Object
						}
					]
				})
			} else {
				this.setState({
					isUploadingSummaryImage: false
				})
				message.error("上传图片 " + event.file.name + " 出错, " + result.data.Errors[0], 4)
			}
		}, error => {
			this.setState({ isUploadingSummaryImage: false })
			message.error("上传图片出错", 4)
		}))
	}

	previewSummaryImage = image => this.setState({
		summaryImagePreviewVisiable: true,
		summaryImagePreviewImage: image.url
	})

	removeSummaryImage = image => {
		const imageIndex = this.state.summary_images.map(image => image.uid).indexOf(image.uid)
		this.setState({
			summary_images: [
				...this.state.summary_images.slice(0, imageIndex),
				...this.state.summary_images.slice(imageIndex + 1)
			]
		})
	}

	toggleSummaryImagePreviewModal = () => this.setState({
		summaryImagePreviewVisiable: !this.state.summaryImagePreviewVisiable
	})

	////////////End of upload summary image////////////////

	render() {
		const reportColumn = [{
			title: <div><div>报告时间</div><div>Report Time</div></div>,
			dataIndex: 'created_time_str',
			key: 'created_time',
		}, {
			title: <div><div>回复时间</div><div>Reply Time</div></div>,
			dataIndex: 'reply_time_str',
			key: 'reply_time',
		}, {
			title: <div><div>状态</div><div>Status</div></div>,
			dataIndex: 'status_name',
			key: 'status_name',
		}, {
			title: <div><div>操作</div><div>Action</div></div>,
			dataIndex: 'action',
			key: 'action',
			className: "daily-report-action",
			render: (text, record, index) => (
				<span>
					{record.status === 0 ?
						<span>
							{(this.props.access.myWeeklyReport.u_value || this.props.access.employeeMyWeeklyReport.u_value) &&
								<Button icon="edit" size="small" className="row-action-btn"
									onClick={this.updateWeeklyReport.bind(this, record, index, false)}>编辑 Edit</Button>
							}
							{(this.props.access.myWeeklyReport.submit_value || this.props.access.employeeMyWeeklyReport.u_value) &&
								<Button icon="save" size="small" className="row-action-btn"
									onClick={this.submitReportOld.bind(this, record, index)}>提交 Submit</Button>
							}
						</span>
						:
						<span>
							{(this.props.access.myWeeklyReport.detail_value || this.props.access.employeeMyWeeklyReport.c_value) && <Button icon="info-circle-o" size="small" className="row-action-btn"
								onClick={this.updateWeeklyReport.bind(this, record, index, true)}>详情 View</Button>}
						</span>}
				</span>
			)
		}
		];
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					centered={true}
					visible={this.state.currentModalStatus}
					title="&nbsp;"
					maskClosable={false}
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					footer={[
						(this.props.access.myWeeklyReport.save_value || this.props.access.employeeMyWeeklyReport.u_value) && this.state.openDetail ? null : <Button key="保存" type="primary"
							onClick={this.saveCurrentReport.bind(this, 0)} disabled={this.state.loading} loading={this.state.loading}>保存</Button>,
						(this.props.access.myWeeklyReport.submit_value || this.props.access.employeeMyWeeklyReport.u_value) && this.state.openDetail ? null : <Button key="提交" type="primary"
							onClick={this.submitCurrentReport.bind(this, 1)} disabled={this.state.submitLoading} loading={this.state.submitLoading}>提交</Button>,
						// <Button key="关闭" onClick={this.closeCurrentModal}>关闭</Button>,
					]}>
					<div style={{ textAlign: "center", margin: "0px 0px 5px", height: "700px", overflowY: "auto", padding: "0px 15px" }}>
						<Row style={{}}>
							<Col span={18} style={{ fontSize: "32px", height: "95px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Weekly Work Report</span><br />
								<span style={{ fontSize: "20px", fontWeight: "bold", paddingLeft: "5px" }}>周工作报告</span>
							</Col>
							<Col span={6} style={{ fontSize: "16px", height: "30px", lineHeight: "30px", textAlign: "right" }}>
								<span style={{}}>{this.state.district}</span>
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingTop: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Name 姓名 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.real_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Date 日期 : </span>
								<DatePicker style={{ width: "120px" }} onChange={this.setStartDate}
									value={this.state.date_1 ? moment(this.state.date_1, "YYYY-MM-DD") : null} /> - <DatePicker style={{ width: "120px" }} onChange={this.setEndDate}
										value={this.state.date_2 ? moment(this.state.date_2, "YYYY-MM-DD") : null} />
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingBottom: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Department 部门 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.department_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Position 岗位 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.position_name}</span>
							</Col>
						</Row>

						{/* 普通外教周报(转正后)*/}
						{/* {this.state.isforeign &&
							<div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											Class Evaluations and Feedback
                  </div>
									</Col>
								</Row>
								<Row style={{ backgroundColor: "white", minHeight: "40px", lineHeight: "40px", display: 'flex', flexWrap: 'wrap' }}>
									<Col  style={{ border: "1px solid #cccccc", textAlign: "left",paddingLeft:"5px" }} span="8">
										Class Code:<Input disabled={this.props.openDetail} value={child.value} style={{width:"100%"}}
																onChange={this.changeColumnItemValue.bind(this, tableIndex, childIndex)} /></Col>
								</Row>
							</div>
						} */}

						{/* 除普通外教周报外,通用格式 */}
						{this.state.isforeign &&
							<div>
								{/* <Button key="addEva" onClick={this.closeCurrentModal}>Add Class Evaluations and Feedback</Button> */}
								<div style={{ textAlign: "right" }}>
									<Button type="primary" onClick={this.AddClassEva}>
										<span>Add </span>
									</Button>
								</div>
								<div style={{ height: "10px", border: "0" }}></div>
								<WorkReportTemplate currentData={this.state.weeklyReportTemplate}
									editReportContent={this.editReportContent}
									openDetail={this.state.openDetail} />
							</div>
						}
						{!this.state.isforeign &&

							<WorkReportTemplate currentData={this.state.weeklyReportTemplate}
								editReportContent={this.editReportContent}
								openDetail={this.state.openDetail} />
						}
						{/* 普通周报额外添加 */}
						{this.state.isAddtion &&
							<div>

								{((this.state.images && 0 !== this.state.images.length) || !this.state.openDetail) &&
									<div style={{ padding: "15px", border: "2px solid #cccccc" }}>
										<Upload multiple
											fileList={this.state.images}
											listType="picture-card"
											disabled={this.state.openDetail}
											beforeUpload={this.checkFileType}
											customRequest={this.uploadCertificateImage}
											showUploadList={{
												showPreviewIcon: true,
												showRemoveIcon: !this.state.openDetail
											}}
											onPreview={this.previewCertificate}
											onRemove={this.removeCertificate}>
											{!this.state.openDetail &&
												<div>
													<Icon type="plus" />
													<div style={{ margin: "8px 0px 0px", color: "#999999" }}>上传图片</div>
												</div>}
										</Upload>
										<Modal visible={this.state.certificatePreviewVisiable}
											footer={null}
											onCancel={this.toggleCertificatePreviewModal}>
											<img alt="example" style={{ width: '100%' }} src={this.state.certificatePreviewImage} />
										</Modal>
										<div style={{ clear: "both" }}></div>
									</div>}

								<div style={{ height: "10px", border: "0" }}></div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											本周工作总结
                  </div>
									</Col>
									<Col span={24} >
										<div style={{ minHeight: "40px", lineHeight: "40px", border: "1px solid #cccccc", padding: "5px 15px" }}>
											<Form.Item>
												{this.props.form.getFieldDecorator("summary", {
													rules: [{ required: false }],
													initialValue: this.state.summary && this.state.summary
												})(<Input.TextArea rows={4} autosize={{ minRows: 4, maxRows: 999 }}

													placeholder={"请输入工作总结"}
													style={{ width: "98%" }} />)}
											</Form.Item>

											{((this.state.summary_images && 0 !== this.state.summary_images.length) || !this.state.openDetail) &&
												<div style={{ padding: "8px" }}>
													<Upload multiple
														fileList={this.state.summary_images}
														listType="picture-card"
														disabled={this.state.openDetail}
														beforeUpload={this.checkFileType}
														customRequest={this.uploadSummaryImage}
														showUploadList={{
															showPreviewIcon: true,
															showRemoveIcon: !this.state.openDetail
														}}
														onPreview={this.previewSummaryImage}
														onRemove={this.removeSummaryImage}>
														{!this.state.openDetail &&
															<div>
																<Icon type="plus" />
																<div style={{ margin: "8px 0px 0px", color: "#999999" }}>上传图片</div>
															</div>}
													</Upload>
													<Modal visible={this.state.summaryImagePreviewVisiable}
														footer={null}
														onCancel={this.toggleSummaryImagePreviewModal}>
														<img alt="example" style={{ width: '100%' }} src={this.state.summaryImagePreviewImage} />
													</Modal>
													<div style={{ clear: "both" }}></div>
												</div>}

										</div>
									</Col>
								</Row>
								<div style={{ height: "10px", border: "0" }}></div>

								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											本周最佳员工
                  </div>
									</Col>

									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_id_1", {
													rules: [{
														required: false,
														message: ''
													}],
													initialValue: this.state.currentData && this.state.currentData.employee_name_1
												})(
													<Select mode="combobox"
														style={{ width: "220px" }}
														onSearch={this.selectEmployee1}
														filterOption={false}
														onSelect={this.setBest1}
														placeholder={""} >
														{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
															this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id}
																		value={employee.english_name}
																		employee_id={employee.id}
																		style={{ width: "200px", paddingLeft: "20px" }}>
																		{employee.english_name}
																	</Select.Option>
																)
															})}
													</Select>
												)}
											</Form.Item>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_1_reason", {
													initialValue: this.state.currentData && this.state.currentData.employee_1_reason
												})(

													<Input placeholder="推荐原因" style={{ width: "220px", color: "#000000" }} />

												)}
											</Form.Item>
										</div>
									</Col>
									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_id_2", {
													rules: [{
														required: false,
														message: ''
													}],
													initialValue: this.state.currentData && this.state.currentData.employee_name_2
												})(
													<Select mode="combobox"
														style={{ width: "220px" }}
														onSearch={this.selectEmployee2}
														filterOption={false}
														onSelect={this.setBest2}
														placeholder={""}>
														{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
															this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id}
																		value={employee.english_name}
																		employee_id={employee.id}
																		style={{ width: "200px", paddingLeft: "20px" }}>
																		{employee.english_name}
																	</Select.Option>
																)
															})}
													</Select>
												)}
											</Form.Item>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_2_reason", {
													initialValue: this.state.currentData && this.state.currentData.employee_2_reason
												})(

													<Input placeholder="推荐原因" style={{ width: "220px", color: "#000000" }} />

												)}
											</Form.Item>
										</div>
									</Col>
									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_id_3", {
													rules: [{
														required: false,
														message: ''
													}],
													initialValue: this.state.currentData && this.state.currentData.employee_name_3
												})(
													<Select mode="combobox"
														style={{ width: "220px" }}
														onSearch={this.selectEmployee3}
														filterOption={false}
														onSelect={this.setBest3}
														placeholder={""} >
														{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
															this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id}
																		value={employee.english_name}
																		employee_id={employee.id}
																		style={{ width: "200px", paddingLeft: "20px" }}>
																		{employee.english_name}
																	</Select.Option>
																)
															})}
													</Select>
												)}
											</Form.Item>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_3_reason", {
													initialValue: this.state.currentData && this.state.currentData.employee_3_reason
												})(

													<Input placeholder="推荐原因" style={{ width: "220px", color: "#000000" }} />

												)}
											</Form.Item>
										</div>
									</Col>
								</Row>
								<div style={{ height: "10px", border: "0" }}></div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											本周问题反馈(包括家长投诉需求及心得反馈、与其他部门沟通事项)
                  </div>
									</Col>
									<Col span={24} >
										<div style={{ minHeight: "40px", lineHeight: "40px", border: "1px solid #cccccc", padding: "5px 15px" }}>
											<Form.Item>
												{this.props.form.getFieldDecorator("question", {
													rules: [{ required: false }],
													initialValue: this.state.currentData && this.state.currentData.question
												})(<Input.TextArea rows={8} autosize={{ minRows: 4, maxRows: 999 }}
													placeholder={"请输入问题反馈"}
													style={{ width: "98%" }} />)}
											</Form.Item>
										</div>
									</Col>
								</Row>
							</div>
						}
						<div style={{ height: "10px", border: "0" }}></div>
						{this.state.openDetail &&
							<div style={{ textAlign: "left", lineHeight: "30px", margin: "15px 0px" }}>
								<p>报告回复列表 : </p>
								{this.state.replies && this.state.replies.map(reply => {
									return (<div key={reply.id}>
										<span style={{ color: "blue" }}>{reply.real_name}</span>
										<span> ( </span>
										<span style={{ color: "blue" }}>
											{reply.reply_time ? moment(reply.reply_time).format("YYYY-MM-DD HH:MM") : ""}
										</span>
										<span> ) </span>
										<span> 回复 : </span>
										<span>{reply.content}</span>
									</div>)
								})}
							</div>}
						<hr style={{ height: "1px", border: "none", borderTop: "3px solid #555555" }} />
						<div>
							<img src={logoImg} alt="logo" style={{ float: "left", width: "110px", height: "auto" }} />
							<div style={{ float: "right", fontSize: "12px", height: "18px", lineHeight: "16px", textAlign: "left" }}><span>Tel: 400 6666 321</span><br /><span>www.egiraffe.com.cn</span><br /><span>GSH.20171101</span></div>
						</div>
					</div>
				</Modal>
				<div style={{ marginBottom: "20px" }}>
					{(this.props.access.myWeeklyReport.c_value || this.props.access.employeeMyWeeklyReport.c_value) &&
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.newWeeklyReport}>
								<Icon type="plus-circle-o" />
								<span>新增 New</span>
							</Button>
						</div>
					}
					{(this.props.access.myWeeklyReport.d_value || this.props.access.employeeMyWeeklyReport.d_value) &&
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.multiDeleteWeeklyReport}>
								<Icon type="delete" />
								<span>批量删除 Batch Delete</span>
							</Button>
						</div>
					}
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>开始时间 Start Time: </span>
						<DatePicker onChange={this.setStartDateFilter}
							value={this.props.workReport.weeklyReportFilters.start_date ?
								moment(this.props.workReport.weeklyReportFilters.start_date, "YYYY-MM-DD") :
								null} />
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>结束时间 End Time: </span>
						<DatePicker onChange={this.setEndDateFilter}
							value={this.props.workReport.weeklyReportFilters.end_date ?
								moment(this.props.workReport.weeklyReportFilters.end_date, "YYYY-MM-DD") :
								null} />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Radio.Group defaultValue={this.props.workReport.weeklyReportFilters.status}
							onChange={this.setStatusFilter}>
							<Radio.Button value={false}>全部 All</Radio.Button>
							<Radio.Button value="0">未提交 Unsubmit</Radio.Button>
							<Radio.Button value="1">未回复 Unreply</Radio.Button>
							<Radio.Button value="2">已回复 Replied</Radio.Button>
						</Radio.Group>
					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				<div>
					{(() => {
						switch (this.props.workReport.weeklyReportStatus) {
							case "loaded":
								return (
									<Table columns={reportColumn}
										dataSource={this.props.workReport.weeklyReportData.Data}
										rowKey={record => record.id}
										rowSelection={this.rowSelection}
										pagination={{
											total: this.props.workReport.weeklyReportData.Total,
											pageSize: this.props.workReport.weeklyReportData.pageSize,
											current: this.props.workReport.weeklyReportFilters.page
										}}
										onChange={this.setPageFilter} />);
							case "error":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										<Spin size="large" />
									</div>);
							default:
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		workReport: state.workReport,
		routing: state.routing,
		employeeManagement: state.employeeManagement,
	}
}
const mapDispatchToProps = {
	increaseWeeklyReportLoadCounter,
	fetchWeeklyReportList,
	setWeeklyReportFilter,
	updateWeeklyReport,
	submitWeeklyReport,
	fetchEmployeesList,
	submitCurrentWeeklyReport,
}

WeeklyReport = Form.create()(WeeklyReport);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(WeeklyReport));




// WEBPACK FOOTER //
// ./src/routes/WorkReport/WeeklyReportEn.js